/* PD sidebar: mobile slide-out drawer + rail accordion. No dependencies. */
(function () {
  "use strict";
  var aside = document.querySelector("[data-pd-aside]");
  if (!aside) return;
  var overlay = document.querySelector(".pd-aside__overlay");
  // The drawer range, same as pd-aside.css (max-width 1279.98px). It was 1023.98, so on an iPad in landscape / an
  // iPad Pro (1024-1279px) the burger click went to Hyper's own, now empty, menu drawer (merchant 2026-09-27).
  var mq = window.matchMedia("(max-width: 1279.98px)");
  var lastFocus = null;

  /* ---------- drawer ---------- */
  function openDrawer() {
    if (aside.classList.contains("is-open")) return;
    lastFocus = document.activeElement;
    aside.classList.add("is-open");
    if (overlay) overlay.hidden = false;
    document.body.classList.add("pd-aside-open");
    var closeBtn = aside.querySelector("[data-pd-aside-close]");
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!aside.classList.contains("is-open")) return;
    aside.classList.remove("is-open");
    if (overlay) overlay.hidden = true;
    document.body.classList.remove("pd-aside-open");
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  // Hyper's burger (mobile header) opens OUR drawer instead of the theme's menu-drawer.
  document.addEventListener("click", function (e) {
    var burger = e.target.closest(".header__icons--left .menu-drawer-button");
    if (burger && mq.matches) { e.preventDefault(); e.stopPropagation(); openDrawer(); return; }
    if (e.target.closest("[data-pd-aside-close]")) { e.preventDefault(); closeDrawer(); return; }
    var garage = e.target.closest("[data-pd-aside-garage]");
    if (garage) {
      e.preventDefault();
      closeDrawer();
      var trigger = document.querySelector("[data-gw-open]");
      if (trigger) setTimeout(function () { trigger.click(); }, 120);
      else window.location.href = "/pages/find-dele";
    }
  }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && aside.classList.contains("is-open")) closeDrawer();
  });
  mq.addEventListener("change", function (ev) { if (!ev.matches) closeDrawer(); });
  // pd-nav.js closes the drawer when one of its links starts a page transition on a phone
  window.pdAside = { close: closeDrawer, isOpen: function () { return aside.classList.contains("is-open"); } };

  /* ---------- rail accordion ---------- */
  function setOpen(item, open) {
    var sub = item.querySelector(".pd-rail__sub");
    var btn = item.querySelector("[data-pd-rail-toggle]");
    item.classList.toggle("is-open", open);
    if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
    if (!sub) return;
    if (open) {   // unfold to the real height at the same pace as the close
      if (!sub.hidden && !sub.classList.contains("is-closing")) return;   // already open (e.g. a sub-category of the open category): keep it as it is, no re-unfold
      sub.classList.remove("is-closing"); sub.classList.add("is-animating"); sub.hidden = false;
      clearTimeout(sub._aTimer); sub._aTimer = setTimeout(function () { sub.classList.remove("is-animating"); }, 1200);
      sub.style.setProperty("--h", sub.scrollHeight + "px");
      clearTimeout(sub._hTimer); sub._hTimer = setTimeout(function () { sub.style.removeProperty("--h"); }, 700);
      return;
    }
    if (sub.hidden || sub.classList.contains("is-closing")) return;
    // ease the old category shut instead of removing it instantly
    clearTimeout(sub._hTimer);
    sub.style.setProperty("--h", sub.scrollHeight + "px");
    sub.classList.add("is-closing");
    var done = false;
    var finish = function () { if (done) return; done = true; sub.classList.remove("is-closing"); sub.hidden = true; sub.style.removeProperty("--h"); };
    sub.addEventListener("animationend", function (e) { if (e.target === sub) finish(); });
    setTimeout(finish, 520);
  }
  // accordion: the open category eases shut first; only then the next one unfolds
  function switchTo(rail, item, open) {
    var others = Array.prototype.filter.call(rail.querySelectorAll("[data-pd-rail-item].is-open"), function (o) { return o !== item && o.querySelector(".pd-rail__sub"); });
    others.forEach(function (o) { setOpen(o, false); });
    if (!item) return;
    if (open === false) { setOpen(item, false); return; }
    if (!others.length) { setOpen(item, true); return; }
    var opened = false, go = function () { if (!opened) { opened = true; setOpen(item, true); } };
    var sub = others[0].querySelector(".pd-rail__sub");
    sub.addEventListener("animationend", function (e) { if (e.target === sub) go(); });
    setTimeout(go, 600);
  }
  // close every other open category; resolves when the close animation is done (or right away)
  function closeOthers(rail, item) {
    var others = Array.prototype.filter.call(rail.querySelectorAll("[data-pd-rail-item].is-open"), function (o) { return o !== item && o.querySelector(".pd-rail__sub"); });
    if (!others.length) return Promise.resolve(false);
    return new Promise(function (resolve) {
      var done = false, fin = function () { if (!done) { done = true; resolve(true); } };
      var sub = others[0].querySelector(".pd-rail__sub");
      sub.addEventListener("animationend", function (e) { if (e.target === sub) fin(); });
      others.forEach(function (o) { setOpen(o, false); });
      setTimeout(fin, 600);
    });
  }
  window.pdRail = { setOpen: setOpen, switchTo: switchTo, closeOthers: closeOthers, open: function (item) { if (item) setOpen(item, true); } };

  // the bike card on top of the rail: which motorcycle the shop is filtered for, and a way to change it
  function vcard() {
    var card = document.querySelector("[data-pd-vcard]"); if (!card) return;
    // active bike: from the app when it is up, otherwise straight from its localStorage keys (the app script
    // loads late; rendering the "choose" state in the meantime made the card flip for a moment)
    var fw = window.FitmentWidgets, v = null;
    if (fw && fw.getActiveVehicle) v = fw.getActiveVehicle();
    else { try { var k = localStorage.getItem("fitment_garage_active") || "", l = JSON.parse(localStorage.getItem("fitment_garage") || "[]"); for (var i = 0; i < l.length; i++) { var x = l[i]; if (x && (x.year + "|" + x.make + "|" + x.model) === k) { v = x; break; } } } catch (e) {} }
    var asideEl = card.closest(".pd-aside"); if (asideEl && !(window.Shopify && window.Shopify.designMode)) asideEl.classList.toggle("pd-no-bike", !v);   // the rail's "All parts for my vehicle" link only makes sense with a bike
    var lab = function (key, def) { return card.dataset["label" + key] || def; };   // pd.aside.* / pd.collection.change locale keys via data attributes (English defaults, translated in the theme language editor)
    var logo = card.querySelector("[data-pd-vcard-logo]"), label = card.querySelector("[data-pd-vcard-label]"), name = card.querySelector("[data-pd-vcard-name]"), btn = card.querySelector("[data-pd-vcard-btn]");
    card.classList.toggle("pd-vcard--empty", !v);
    if (v) {
      label.textContent = lab("Bike", "Your motorcycle");
      name.textContent = [v.year, v.makeDisplay || v.make, v.modelDisplay || v.model].filter(Boolean).join(" ");
      btn.textContent = lab("Change", "Change");
      var base = window.__pdBikeIcon || "", slug = String(v.make || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
      try { if (base) localStorage.setItem("pd_brand_base", base); else base = localStorage.getItem("pd_brand_base") || ""; } catch (e) {}   // remembered so the next page can paint the logo at once
      if (base && slug && (logo.dataset.slug !== slug || logo.dataset.base !== base)) {   // base differs = the pre-paint script used a remembered URL from an older app version
        logo.dataset.slug = slug; logo.dataset.base = base; logo.innerHTML = ""; logo.classList.remove("has-logo");
        var img = new Image(); img.alt = ""; img.src = base.replace(/motorcycle_icon\.png/, "brand-" + slug + ".png");
        img.onload = function () { if (logo.dataset.base !== base) return; logo.innerHTML = ""; logo.appendChild(img); logo.classList.add("has-logo"); };
        img.onerror = function () { if (logo.dataset.base !== base) return; logo.classList.remove("has-logo"); logo.dataset.slug = ""; };
      }
    } else {
      /* empty state mirrors the header pill: small "My garage" over a bold "Select bike" */
      label.textContent = lab("Garage", "My garage"); name.textContent = lab("Choose", "Select bike"); btn.textContent = "→"; logo.innerHTML = ""; logo.classList.remove("has-logo"); logo.dataset.slug = "";
    }
    card.hidden = false; card.style.visibility = "";
    if (!card._pdWired) { card._pdWired = true; var go = function () { var trig = document.querySelector("[data-gw-open]"); if (trig) trig.click(); else location.href = "/pages/find-dele"; }; btn.addEventListener("click", go); card.addEventListener("click", function (e) { if (e.target === card || e.target.closest(".pd-vcard__text, .pd-vcard__logo")) go(); }); }
  }
  vcard(); var vcTries = 0; var vcPoll = setInterval(function () { vcard(); if (window.FitmentWidgets || ++vcTries > 20) clearInterval(vcPoll); }, 150);
  window.addEventListener("fitment:garage-updated", function () { setTimeout(vcard, 50); });
  // scrollbar width for the scroll-lock compensation (garage popup, search overlay, slide-out panel, filter drawer)
  // A lock sets overflow:hidden on html+body; whether that removes the scrollbar depends on the browser
  // (overlay vs classic, scrollbar-gutter) — so compare the scrollbar's width now with its width while
  // unlocked and pad the body by exactly what vanished. Widths, not the page width: a remembered page
  // width went stale when the window was resized or zoomed while a lock was on, and the next lock then
  // padded by hundreds of px and pushed the whole page to the left (merchant 2026-09-23, image 4).
  var sbwNow = function () { return Math.max(0, window.innerWidth - document.documentElement.clientWidth); };
  var sbwUnlocked = sbwNow();
  function anyLock() {
    var b = document.body.classList, h = document.documentElement.classList;
    return b.contains("gw-lock") || h.contains("gw-lock") || b.contains("fps-full-open") || h.contains("fps-full-open") || b.contains("pd-panel-open") || b.contains("pd-filters-open");
  }
  function lockPad() {
    // Only the GARAGE lock is padded: the theme releases its gutter (html.gw-lock { scrollbar-gutter: auto })
    // so the scrollbar really vanishes and the diff is real. The search overlay is deliberately NOT: on
    // the merchant's Windows Chrome a blank gutter stays under its overflow:hidden and padding on top of
    // that pushed the page left (2026-09-23) — the overlay itself covers the gutter (width: 100vw).
    var h = document.documentElement.classList, b = document.body.classList;
    var locked = h.contains("gw-lock") || b.contains("gw-lock");
    if (!locked) { document.documentElement.style.removeProperty("--pd-lock-pad"); if (!anyLock()) sbwUnlocked = sbwNow(); return; }
    var diff = Math.max(0, sbwUnlocked - sbwNow());   // 17 where the scrollbar vanished, 0 where a blank gutter stays or scrollbars are overlays
    // The pad itself is a CSS rule on body.gw-lock / body.fps-full-open reading this property
    // (pd-aside.css) — an inline style lost to Hyper's `.search-open { padding-right: 0 !important }`.
    document.documentElement.style.setProperty("--pd-lock-pad", diff + "px");   // full-bleed bars (topbar, header, footer) extend under the pad so they still reach the window edge
  }
  new MutationObserver(lockPad).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  new MutationObserver(lockPad).observe(document.body, { attributes: true, attributeFilter: ["class"] });
  function sbw() {
    if (anyLock()) return;   // locked (garage, search overlay, panel, filters): the scrollbar may be gone, keep the last measurement
    sbwUnlocked = sbwNow();
    document.documentElement.style.setProperty("--pd-sbw", sbwUnlocked + "px");
  }
  sbw(); window.addEventListener("resize", sbw);
  document.querySelectorAll("[data-pd-rail]").forEach(function (rail) {
    var single = rail.hasAttribute("data-single-open");
    rail.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-pd-rail-toggle]");
      if (!btn) return;
      e.preventDefault();
      var item = btn.closest("[data-pd-rail-item]");
      var willOpen = !item.classList.contains("is-open");
      if (single && willOpen) switchTo(rail, item, true); else setOpen(item, willOpen);
    });
    // Mobile: open the first category by default when nothing is active (design 4c)
    if (rail.hasAttribute("data-mobile-open-first") && mq.matches && !rail.querySelector("[data-pd-rail-item].is-open")) {
      var first = rail.querySelector("[data-pd-rail-item]");
      if (first && first.querySelector(".pd-rail__sub")) setOpen(first, true);
    }
  });
})();

/* Phones: the garage popup is a bottom sheet (pd-theme.css). When its content swaps — garage list ↔
   "Tilføj motorcykel" form — the sheet's auto height would jump; height:auto cannot transition, so
   this measures the old and new height and lets the sheet travel between them (FLIP) through
   --pd-sheet-h, which the theme's height rule reads. Merchant 2026-09-23: "animere lækkert og
   smooth ease-in-out op". */
(function () {
  var mq = window.matchMedia("(max-width: 767.98px)");
  if (!("ResizeObserver" in window)) return;
  function wire() {
    var p = document.querySelector(".gw__panel"); if (!p || p._pdSheet) return !!p;
    p._pdSheet = true;
    var last = 0, animating = false;
    function settle() { animating = false; p.style.removeProperty("--pd-sheet-h"); last = p.getBoundingClientRect().height; }
    p.addEventListener("transitionend", function (e) { if (e.target === p && e.propertyName === "height" && animating) settle(); });
    new ResizeObserver(function () {
      if (!mq.matches || p.hidden || animating) return;
      var h = p.getBoundingClientRect().height;
      if (!last || Math.abs(h - last) < 3) { last = h; return; }   // first open / no real change: nothing to travel
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { last = h; return; }
      animating = true;
      p.style.setProperty("--pd-sheet-h", last + "px");            // 1. snap back to the old height (content already swapped)
      void p.offsetHeight;                                            // 2. commit it
      p.style.setProperty("--pd-sheet-h", h + "px");                 // 3. travel to the new one (CSS transition on height)
      setTimeout(function () { if (animating) settle(); }, 500);      // safety: never stay pinned
    }).observe(p);
    return true;
  }
  if (!wire()) { var tries = 0, t = setInterval(function () { if (wire() || ++tries > 40) clearInterval(t); }, 250); }   // the app mounts the panel after load
})();

/* The app's full-screen search overlay renders the SAME .pd-card markup as the feed. Tag it so the
   shared card styles apply there too (see pd-feed-cards.css "pd-cardset"). */
(function () {
  var tag = function () { document.querySelectorAll(".fps-full:not(.pd-cardset)").forEach(function (el) { el.classList.add("pd-cardset"); }); };
  tag();
  new MutationObserver(tag).observe(document.documentElement, { childList: true, subtree: true });
})();
